import React from "react";
import { DownloadTemplateModal } from "./DownloadTemplateModal";

type DownloadTemplateContextValue = { open: (openapiProductId: number) => void };

const DownloadTemplateContext = React.createContext<DownloadTemplateContextValue | null>(null);

// Opens the Download Template modal for a product. Must be used within a DownloadTemplateProvider.
export function useDownloadTemplateModal(): DownloadTemplateContextValue {
  const context = React.useContext(DownloadTemplateContext);
  if (!context) {
    throw new Error("useDownloadTemplateModal must be used within a DownloadTemplateProvider");
  }
  return context;
}

// Single owner of the modal's open state, so the row menu and details panel just call `open(id)`.
export function DownloadTemplateProvider({ children }: { children: React.ReactNode }) {
  const [openapiProductId, setOpenapiProductId] = React.useState<number | null>(null);
  const value = React.useMemo<DownloadTemplateContextValue>(
    () => ({ open: (id: number) => setOpenapiProductId(id) }),
    []
  );

  return (
    <DownloadTemplateContext.Provider value={value}>
      {children}
      <DownloadTemplateModal
        opened={openapiProductId !== null}
        openapiProductId={openapiProductId ?? undefined}
        onClose={() => setOpenapiProductId(null)}
      />
    </DownloadTemplateContext.Provider>
  );
}
